import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import Cta from "../Components/Cta";

const TermsConditions=()=>{
    const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const itemVariant = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

useEffect(() => {
    document.title =
      "Terms & Conditions | ONBBITS";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Review the ONBBITS Terms & Conditions covering platform usage, user responsibilities, account policies and service agreements."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/terms-conditions");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Terms & Conditions | ONBBITS"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Review the ONBBITS Terms & Conditions covering platform usage, user responsibilities, account policies and service agreements."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/terms-conditions");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Terms & Conditions | ONBBITS"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Review the ONBBITS Terms & Conditions covering platform usage, user responsibilities, account policies and service agreements."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }
  }, [])

    return(
        <>
         {/**BREADCRUMB */}
        <Breadcrumb title="Terms And Conditions" />

        <motion.section
    className="policy-section container"
    variants={stagger}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.05 }}
>
           <motion.p
    className="section-text"
    variants={itemVariant}>Welcome to ONBBITS, a SaaS platform providing WhatsApp automation and chatbot building services. These Terms and Conditions ("Terms") govern your use of our services provided by Onbbits ("Company", "we", "us", or "our").</motion.p>
           <motion.p
    className="section-text"
    variants={itemVariant}>By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of these Terms, please discontinue using the Service.</motion.p>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>1. Acceptance of Terms</motion.h2>
           <motion.p
    className="section-text"
    variants={itemVariant}>By creating an account, accessing, or using ONBBITS in any manner, you acknowledge that you have read, understood, and agree to be bound by these Terms and our Privacy Policy. These Terms constitute a legally binding agreement between you and Onbbits.</motion.p>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>2. Description of Service</motion.h2>
           <motion.p
    className="section-text"
    variants={itemVariant}>ONBBITS provides the following services:</motion.p>
            <motion.ul variants={itemVariant}>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>WhatsApp automation and chatbot building tools</motion.li>
              <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Integration with WhatsApp Business API</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Analytics and reporting features</motion.li>
              <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Customer support and maintenance</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Other software-as-a-service functionalities</motion.li>
             </motion.ul>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>3. User Accounts and Registration</motion.h2>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>3.1 Account Creation</motion.h3>
            <motion.ul variants={itemVariant}>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You must provide accurate, current, and complete information during registration.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You are responsible for maintaining the confidentiality of your account credentials.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You must be at least 18 years old to create an account.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Each person or entity may maintain only one account.</motion.li>
            </motion.ul>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>3.2 Account Security</motion.h3>
           <motion.ul variants={itemVariant}>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You are responsible for all activities that occur under your account.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Notify us immediately of any unauthorized use of your account.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>We are not liable for any loss or damage arising from unauthorized account access.</motion.li>
             </motion.ul>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>4. Subscription and Payment Terms</motion.h2>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>4.1 Subscription Plans</motion.h3>
            <motion.ul variants={itemVariant}>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Various subscription plans are available with different features and limitations.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Subscription fees are billed in advance on a monthly or annual basis.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>All fees are non-refundable except as expressly stated in our Refund Policy.</motion.li>
             </motion.ul>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>4.2 Payment Processing</motion.h3>
            <motion.ul variants={itemVariant}>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Payments are processed through secure third-party payment processors.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You authorize us to charge your payment method for all applicable fees.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You are responsible for all applicable taxes related to your use of the Service.</motion.li>
             </motion.ul>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>4.3 Price Changes</motion.h3>
            <motion.p
    className="section-text"
    variants={itemVariant}>We reserve the right to modify subscription prices with 30 day's advance notice. Price changes will not affect your current billing cycle.</motion.p>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>5. Acceptable Use Policy</motion.h2>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>5.1 Permitted Use</motion.h3>
          <motion.p
    className="section-text"
    variants={itemVariant}>You may use ONBBITS only for lawful business purposes in accordance with these Terms.</motion.p>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>5.2 Prohibited Activities</motion.h3>
           <motion.p
    className="section-text"
    variants={itemVariant}>You agree not to:</motion.p>
            <motion.ul variants={itemVariant}>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Send spam, unsolicited messages, or violate anti-spam laws.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Engage in illegal, harmful, or fraudulent activities.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Violate WhatsApp's Terms of Service or Business Policy.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Attempt to gain unauthorized access to our systems.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Reverse engineer, decompile, or disassemble our software.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Use the Service to compete with or replicate a similar service.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Share your account access with unauthorized third parties.</motion.li>
             </motion.ul>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>6. Data and Privacy</motion.h2>
           <motion.p
    className="section-text"
    variants={itemVariant}>Your privacy is important to us. Our collection and use of personal information are governed by our Privacy Policy, which forms an integral part of these Terms.</motion.p>
           <motion.ul variants={itemVariant}>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You retain ownership of your business data and content.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>We may access your data only as necessary to provide the Service.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You are responsible for ensuring you have rights to any data you upload.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You must comply with all applicable data protection laws.</motion.li>
             </motion.ul>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>7. Intellectual Property</motion.h2>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>7.1 Our Rights</motion.h3>
            <motion.p
    className="section-text"
    variants={itemVariant}>ONBBITS, along with all related software, technology, and content, is owned by Onbbits and protected by applicable intellectual property laws.</motion.p>
           <motion.h3
    className="card-heading"
    variants={itemVariant}>7.2 License Grant</motion.h3>
            <motion.p
    className="section-text"
    variants={itemVariant}>Subject to these Terms, we grant you a limited, non-exclusive, non-transferable license to use ONBBITS during your active subscription period.</motion.p>
           <motion.h2
    className="section-heading"
    variants={fadeUp}>8. Service Availability and Support</motion.h2>
            <motion.ul variants={itemVariant}>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>We strive to maintain high service availability but do not guarantee uninterrupted access.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Scheduled maintenance will be communicated in advance when possible.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Support is provided during business hours via email and our support platform.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>We may temporarily suspend access for maintenance, security, or legal reasons.</motion.li>
             </motion.ul>
           <motion.h2
    className="section-heading"
    variants={fadeUp}>9. Limitation of Liability</motion.h2>
           <motion.p
    className="section-text"
    variants={itemVariant}>To the maximum extent permitted by law:</motion.p>
            <motion.ul variants={itemVariant}>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>Our total liability shall not exceed the amount paid by you in the 12 months preceding the claim.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>We are not liable for indirect, incidental, or consequential damages.</motion.li>
               <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>We do not warrant that the Service will be error-free or uninterrupted.</motion.li>
                <motion.li
    whileHover={{ x: 5 }}
    transition={{ duration: 0.2 }}>You use the Service at your own risk.</motion.li>
            </motion.ul>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>10. Termination</motion.h2>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>10.1 Termination by You</motion.h3>
          <motion.p
    className="section-text"
    variants={itemVariant}>You may terminate your account at any time through your account settings. Termination will take effect at the end of your current billing period.</motion.p>
            <motion.h3
    className="card-heading"
    variants={itemVariant}>10.2 Termination by Us</motion.h3>
           <motion.p
    className="section-text"
    variants={itemVariant}>We may terminate or suspend your account immediately for violations of these Terms or for any other reason at our sole discretion.</motion.p>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>11. Governing Law</motion.h2>
           <motion.p
    className="section-text"
    variants={itemVariant}>These Terms are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of the courts where Onbbits is registered.</motion.p>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>12. Changes to Terms</motion.h2>
           <motion.p
    className="section-text"
    variants={itemVariant}>We reserve the right to modify these Terms at any time. Material changes will be communicated via email or through the Service.</motion.p>
          <motion.p
    className="section-text"
    variants={itemVariant}>Continued use of ONBBITS after such changes constitutes acceptance of the revised Terms.</motion.p>
            <motion.h2
    className="section-heading"
    variants={fadeUp}>13. Contact Information</motion.h2>
           <motion.p
    className="section-text"
    variants={itemVariant}>For questions about these Terms, please contact us:{" "}<a href="mailto:info@onbbits.io">info@onbbits.io</a></motion.p>
        </motion.section>

     {/**CTA SECTION */}
        <Cta/>
        </>
    )
}
export default TermsConditions;